/// <reference path="../../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';

export class ConfirmationPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<AdvertisngConsentAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly parent: AppController;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly user: User;

	constructor(parent: AppController, options: BasicAppOptions<AdvertisngConsentAppDefinition>, loader: BasicLoader<AdvertisngConsentAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.$ctx = $(this.options.$ctx);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.user = user;
	}

	public start(): void {
		const viewConfig = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};
		this.appViewService.render(viewConfig);
	}

	public afterRenderApp(): void {
		T.Utils.Tracking.pushKameleoonData();
		this.parent.afterRenderApp();
		this.appPersistenceService.clearApplicationSession();
		AppUtils.Helper.initRteAuthLinks();
		AppUtils.View.stopLoader();
		AppUtils.View.scrollTop();
	}

	private getViewOptions(): object {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		const advertisingConsentModel = this.appPersistenceService.getAdvertisingConsent();

		return {
			User: this.user,
			Form: formModel,
			AdvertisingConsent: advertisingConsentModel
		};
	}
}
